/** @jsxImportSource @emotion/react */
import { Box, Container, Skeleton } from '@mui/material'
import {
  container,
  content,
  header,
  headerRight,
  mapPane,
  page,
  side,
  sideInner,
} from '../styles/DataLayerDetailPage.styles'

export const DataLayerDetailPageSkeleton = () => {
  return (
    <Box css={page}>
      <Box css={container}>
        <Box css={content}>
          {/* Left: Map skeleton */}
          <Box css={mapPane}>
            <Skeleton variant="rectangular" width="100%" height="100%" />
          </Box>

          {/* Right: Detail panel skeleton */}
          <Box css={side}>
            <Box css={header}>
              <Box css={headerRight}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="text" width={60} height={24} />
              </Box>
            </Box>
            <Container css={sideInner}>
              <Skeleton variant="text" height={40} width="70%" />
              <Skeleton variant="text" height={24} width="90%" />
              <Skeleton variant="text" height={24} width="85%" />
              <Skeleton variant="text" height={24} width="60%" />
              <Skeleton variant="rectangular" height={120} />
              <Skeleton variant="text" height={24} width="80%" />
              <Skeleton variant="text" height={24} width="75%" />
            </Container>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
